/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Document_Preview_UnavailableInputs */

const en_orders_document_preview_unavailable = /** @type {(inputs: Orders_Document_Preview_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview unavailable for this document.`)
};

const es_orders_document_preview_unavailable = /** @type {(inputs: Orders_Document_Preview_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La vista previa no esta disponible para este documento.`)
};

/**
* | output |
* | --- |
* | "Preview unavailable for this document." |
*
* @param {Orders_Document_Preview_UnavailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_document_preview_unavailable = /** @type {((inputs?: Orders_Document_Preview_UnavailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Document_Preview_UnavailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_document_preview_unavailable(inputs)
	return es_orders_document_preview_unavailable(inputs)
});